module.exports = __webpack_public_path__ + "assets/img/4_1554_big.b782ca1b.jpg";